import { getEnvTitlePrefix } from '@folio/utils';
import { useKorintUniqConfig } from 'korint-sdk/react';

export function Title() {
  const { title } = useKorintUniqConfig();

  return <title>{`${getEnvTitlePrefix()}${title}`}</title>;
}
